module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _c('title', [_vm._v("Daily Light: Morning & Evening")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "page9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1a#cc10",
      "id": "dd10"
    }
  }, [_c('i', [_vm._v("January 8")])])]), _vm._v(" "), _c('p', {
    staticClass: "txr5",
    attrs: {
      "id": "amJanuary8"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORNING")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0013-03-2"
    }
  }, [_c('span', [_c('i', [_vm._v("Those who know Your name will put their trust in You; for You, L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", have not forsaken those who seek You")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0013-04-4"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("T")]), _vm._v("he name of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" is a strong tower; the righteous run to it and are safe. • I will trust and not be afraid; ‘for Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AH")]), _vm._v(", the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", is my strength and song; He also has become my salvation.’")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-05-7"
    }
  }, [_vm._v("I have been young, and now am old; yet I have not seen the righteous forsaken, nor his descendants begging bread. • For the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" loves justice, and does not forsake His saints; they are preserved forever, but the descendants of the wicked shall be cut off. • The L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" will not forsake His people, for His great name’s sake, because it has pleased the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" to make you His people. • Who delivered us from so great a death, and does deliver us; in whom we trust that He will still deliver us.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-05-8"
    }
  }, [_vm._v("Be content with such things as you have. For He Himself has said, “I will never leave you nor forsake you.” So we may boldly say: “The L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" is my helper; I will not fear. What can man do to me?”")]), _vm._v(" "), _c('p', {
    staticClass: "txc1"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(". 9:10; P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROV")]), _vm._v(". 18:10; I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SA")]), _vm._v(". 12:2; P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(". 37:25; 37:28; 1 S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AM")]), _vm._v(". 12:22; 2 C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OR")]), _vm._v(". 1:10; H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EB")]), _vm._v(". 13:5–6")]), _vm._v(" "), _c('p', {
    staticClass: "txr5",
    attrs: {
      "id": "aeJanuary8"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VENING")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0013-08-12"
    }
  }, [_c('span', [_c('i', [_vm._v("They are without fault before the throne of God")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0013-09-14"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("T")]), _vm._v("he iniquity of Israel shall be sought, but there shall be none; and the sins of Judah, but they shall not be found; for I will pardon those whom I preserve. • Who is a God like You, pardoning iniquity and passing over the transgression of the remnant of His heritage? He does not retain His anger forever, because He delights in mercy. He will again have compassion on us, and will subdue our iniquities. You will cast all our sins into the depths of the sea.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-10-17"
    }
  }, [_vm._v("He made us accepted in the Beloved. • To present you holy, and blameless, and above reproach in His sight.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-10-18"
    }
  }, [_vm._v("Now to Him who is able to keep you from stumbling, and to present you faultless before the presence of His glory with exceeding joy, to God our Savior, who alone is wise, be glory and majesty, dominion and power, both now and forever. Amen.")]), _vm._v(" "), _c('p', {
    staticClass: "txc1"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EV")]), _vm._v(". 14:5; J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ER")]), _vm._v(". 50:20; M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IC")]), _vm._v(". 7:18–19; E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PH")]), _vm._v(". 1:6; C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OL")]), _vm._v(". 1:22; J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDE VV")]), _vm._v(". 24–25")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7819eb2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter10.vue
// module id = 93
// module chunks = 0